import { Action, Reducer } from 'redux';
import {
  WarehouseState,
  WarehouseTypes,
  WarehouseActionTypes
} from './warehouseTypes';

export const INITIAL_STATE: WarehouseState = {
  warehouse: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const warehouseReducer: Reducer<WarehouseState> = (
  state: WarehouseState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as WarehouseActionTypes;
  switch (actionTypes.type) {
    case WarehouseTypes.GET_WAREHOUSE:
      return {
        ...state,
        warehouse: { ...state.warehouse, isLoading: true }
      };
    case WarehouseTypes.SAVE_WAREHOUSE:
      return {
        ...state,
        warehouse: {
          ...state.warehouse,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case WarehouseTypes.RESET_REDUCER_WAREHOUSE:
      return {
        ...state,
        warehouse: INITIAL_STATE.warehouse
      };
    default:
      return state;
  }
};

export default warehouseReducer;

